// =====================================
//
//   補收款確認退款 Modal
//   Author: Gray
//   createtime: 2017 / 04 / 18
//   updatetime: 2017 / 04 / 18
//
// =====================================

window.InifECMobileApp.directive('confirmExtrafeeRefund', ['$rootScope', '$stateParams', '$timeout', '$ngModal', 'ExtraFeeService',
    function($rootScope, $stateParams, $timeout, $ngModal, ExtraFeeService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            // --------------------------------
            // [private] 打開 Modal
            // --------------------------------
            var openModal = function() {

                $ngModal.openModal('confirm-extrafee-refund-modal');
            }

            // --------------------------------
            // [private] 關閉 Modal
            // --------------------------------
            var closeModal = function() {

                $ngModal.closeModal('confirm-extrafee-refund-modal');
            }

            // --------------------------------
            // 退款
            // --------------------------------
            var confirmRefund = function(){

                if($scope.isRefunding){
                    return;
                }

                $scope.isRefundIssueEmpty = false;
                $scope.isRefundingError = false;

                if(!$scope.form.refundIssue || $scope.form.refundIssue == '') {
                    $scope.isRefundIssueEmpty = true;
                    return;
                } 

                $scope.isRefunding = true;

                ExtraFeeService.refundExtraFee($scope.extrafeeid, $scope.form.refundIssue).then(function(result) {

                    if(result){
                        ($scope.callback) && $scope.callback();
                        closeModal();
                        openSuccessMoadl()
                    } else {
                        $scope.isRefundingError = true;
                    }

                    $scope.isRefunding = false;

                }, function(error){
                   
                    $scope.isRefundingError = true;
                    $scope.isRefunding = false;
                });
            }

            var openSuccessMoadl = function() {

                $rootScope.$broadcast("OPEN_SIMPLE_MESSAGE_MODAL", {
                    viewType: "SIMPLE",
                    title: "已成功申請退款",
                    desc: "我們已收到您的退款申請，客服人員將會與您聯繫，請耐心等候。"
                });
            }

            // --------------------------------
            // [private] 初始化
            // --------------------------------
            var init = function() {

            }

            /*==========================
                Events
            ==========================*/

            $scope.$on("OPEN_CONFIRM_EXTRAFEE_REFUND_MODAL", function(event, data) {

                if(data) {
                    $scope.extrafeeid = data.extrafeeid;
                    $scope.callback = data.callback;

                    $scope.form.refundIssue = '';

                    $scope.isRefundIssueEmpty = false;
                    $scope.isRefundingError = false;
                    $scope.isRefunding = false;

                    openModal();    
                }
            });
                
            /*==========================
                Members
            ==========================*/
            $scope.extrafeeid;
            $scope.form = {
                refundIssue: '',
            };

            $scope.isRefundIssueEmpty = false;
            $scope.isRefundingError = false;
            $scope.isRefunding = false;

            /*==========================
                Methods
            ==========================*/
            $scope.callback = undefined;
            $scope.confirmRefund = confirmRefund; // 退款

            /*==========================
                init
            ==========================*/

            init();

        }]

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'mobile/partials/modal/confirm_extrafee_refund.html';
        _dir.controller = controller;

        return _dir;
}]);